import * as React from 'react';
import { IConstructionProgressStage } from '../../types/constructionProgress';

import { DescriptionText } from './components/DescriptionText';
import { FullscreenGalleryModal } from './components/FullscreenGalleryModal';
import { GalleryCarousel } from './components/GalleryCarousel';
import { Header } from './components/Header';
import { StagesTabs } from './components/StagesTabs';
import { Thumbnails } from './components/Thumbnails';
import { prepareSlides } from './helpers';

export interface IFullscreenGalleryProps {
  initialSlideIndex: number;
  initialStageIndex: number;
  onClose(): void;
  open: boolean;
  stages: IConstructionProgressStage[];
  title?: string;
}

export const FullscreenGallery: React.VFC<IFullscreenGalleryProps> = ({
  initialSlideIndex,
  initialStageIndex,
  onClose,
  open,
  stages,
  title,
}) => {
  const [stageIndex, setStageIndex] = React.useState(initialStageIndex);
  const [slideIndex, setSlideIndex] = React.useState(initialSlideIndex);

  const images = React.useMemo(() => stages[stageIndex]?.images || [], [stages, stageIndex]);
  const { slides, thumbnails } = React.useMemo(() => prepareSlides(images), [images]);
  const description = images[slideIndex]?.text || '';

  const handleStageChange = React.useCallback((index: number) => {
    setStageIndex(index);
    setSlideIndex(0);
  }, []);

  return (
    <FullscreenGalleryModal
      open={open}
      onClose={onClose}
      header={<Header title={title} />}
      slider={<GalleryCarousel slides={slides} slideIndex={slideIndex} onSlideChange={setSlideIndex} />}
      thumbnails={<Thumbnails thumbnails={thumbnails} onThumbnailClick={setSlideIndex} activeIndex={slideIndex} />}
      afterSlider={<DescriptionText text={description} />}
      beforeSlider={<StagesTabs stages={stages} stageIndex={stageIndex} onChange={handleStageChange} />}
    />
  );
};
